type CustomBoxProps = {
  as?: React.ElementType
  children: React.ReactNode
  className?: string
}

const CustomBox = ({
  as: Component = 'div',
  children,
  className,
}: CustomBoxProps) => {
  return <Component className={className}>{children}</Component>
}

export default CustomBox
